import { IDocumentInfo } from '.';
import { DynamicFormInputType, FormInputTypes } from '@components/_old/dynamicForm';
import { FileType } from '@models/file';
import { CDN_URL } from '@utils';

export const ALLOWED_EXTENSIONS = [FileType.xls, FileType.xlsx];

export const initialValues: IDocumentInfo = {
  documentName: '',
  document: {
    id: '',
    location: '',
    path: '',
    fileName: '',
    length: undefined,
    contentType: '',
  },
};

export const inputs = (): Record<string, DynamicFormInputType> => ({
  document: {
    name: 'document',
    title: 'List of Insured',
    type: FormInputTypes.fileuploader,
    value: null,
    required: true,
    disabled: false,
    maxFileSizeInMB: 200,
    allowedFileTypes: ALLOWED_EXTENSIONS,
    imageUrl: '',
    downloadLinks: [
      {
        downloadUrl: CDN_URL + '/files/Medical Group List of Insured.xlsx',
        displayName: 'Download Template',
      },
    ],
  },
});
